<template>
  <div v-if="showPros" class="margin-top-m">
    <ProsCollection
      :recommendation-config="{ zone: 'PDP_ZONE_E', productId, categoryId }"
      :panel-config="{
        customStyleClass: 'custom-zone-e-styling',
        customHeaderType: 'div',
        customRole: 'heading',
        customAriaLevel: '3',
      }"
      @data-load-status-event="loader"
    />
  </div>
</template>

<script setup>
import ProsCollection from '@nuxt-common/pros-collection/app/components/ProsCollection';
import { usePageData } from '~/composables/usePageData';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';
import useProsLoader from '~/composables/utils/useProsLoader';
import { toValue } from 'vue';

const { taxonomy } = useCommonProductGetters();
const categoryId = toValue(taxonomy)?.defaultCategoryId;

const { productId } = usePageData();
const { showPros, loader } = useProsLoader();
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.custom-zone-e-styling {
  .header-container > div:first-child {
    @include header(h3);
  }
}
</style>
